import React from "react";
import LanguageDropDown from "../layout/LanguageDropDown";
import { useTranslation } from "react-i18next";

import classes from "./MainNavigation.module.css";

const MainNavigation = () => {
  const { t } = useTranslation();

  return (
    <>
    <header className={classes.header}>
      <div className={classes.logo}>{t("title")}</div>
      <nav className={classes.nav}>
        {/* <ul>
          <li>
            <NavLink to='/quotes' activeClassName={classes.active}>
              Login
            </NavLink>
          </li>          
        </ul> */}
      </nav>           
    </header>
    <LanguageDropDown /> 
    
    </>
  );
}

export default MainNavigation;